/* LazyPillow hero-animatie: Lazy Dekbed -> wasmachine -> droger -> bed. Transparante achtergrond. */
(function () {
var canvases = document.querySelectorAll('[data-lp-hero-anim]');
if (!canvases.length) return;
var W = 1080, H = 1080, DUR = 8;
var NAVY = '#191B3A', NAVY2 = '#24275A', YEL = '#FFD666', LILA = '#B9B2FF', LILA2 = '#D9D5FF', PINK = '#FFB8CB', WHITE = '#FFFFFF';
var DEK = '#EADCC8', DEK2 = '#D3BFA3', DEK_IN = '#F6EFE4';
var FONT = "'Bricolage Grotesque', sans-serif";
function clamp(v, a, b) { a = a || 0; b = b === undefined ? 1 : b; return Math.max(a, Math.min(b, v)); }
function lerp(a, b, t) { return a + (b - a) * t; }
function seg(t, a, b) { return clamp((t - a) / (b - a)); }
function eio(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
function eout(t) { return 1 - Math.pow(1 - t, 3); }
function ein(t) { return t * t * t; }
var WASH = { x: 150, y: 70, w: 320, h: 330, door: { x: 310, y: 260, r: 100 } };
var DRY = { x: 610, y: 70, w: 320, h: 330, door: { x: 770, y: 260, r: 100 } };
var BED = { x: 150, y: 660, w: 780 };
var FLAT = { cx: 652, cy: 770, w: 540, h: 140, r: 40 };
var WD = WASH.door, DD = DRY.door;
function setup(c) {
var x = c.getContext('2d');
function rr(X, Y, w, h, r) { r = Math.min(r, w / 2, h / 2); x.beginPath(); x.moveTo(X + r, Y); x.arcTo(X + w, Y, X + w, Y + h, r); x.arcTo(X + w, Y + h, X, Y + h, r); x.arcTo(X, Y + h, X, Y, r); x.arcTo(X, Y, X + w, Y, r); x.closePath(); }
function machine(M, kind, t, st) {
x.save(); x.translate(st.shake || 0, 0);
x.fillStyle = 'rgba(0,0,0,.22)'; rr(M.x + 16, M.y + M.h - 6, M.w - 32, 22, 11); x.fill();
x.fillStyle = WHITE; rr(M.x, M.y, M.w, M.h, 44); x.fill();
x.fillStyle = LILA2; rr(M.x + 18, M.y + 18, M.w - 36, 52, 26); x.fill();
x.fillStyle = kind === 'was' ? YEL : PINK; x.beginPath(); x.arc(M.x + M.w - 56, M.y + 44, 14, 0, 7); x.fill();
x.fillStyle = NAVY; x.beginPath(); x.arc(M.x + M.w - 100, M.y + 44, 8, 0, 7); x.fill();
x.fillStyle = NAVY; rr(M.x + 40, M.y + 32, 90, 24, 12); x.fill();
var a = st.active || 0, n = Math.floor((t * 6) % 4);
x.fillStyle = kind === 'was' ? LILA : YEL;
for (var i = 0; i < 3; i++) { x.globalAlpha = a > 0 ? (i <= n ? 1 : .3) : .3; x.beginPath(); x.arc(M.x + 62 + i * 22, M.y + 44, 5, 0, 7); x.fill(); }
x.globalAlpha = 1;
var D = M.door;
x.fillStyle = LILA2; x.beginPath(); x.arc(D.x, D.y, D.r + 18, 0, 7); x.fill();
x.save(); x.beginPath(); x.arc(D.x, D.y, D.r, 0, 7); x.clip();
var gg = x.createRadialGradient(D.x - 30, D.y - 30, 10, D.x, D.y, D.r);
if (kind === 'dry') { gg.addColorStop(0, 'rgba(255,214,102,' + (.25 + .55 * a) + ')'); gg.addColorStop(1, NAVY2); } else { gg.addColorStop(0, '#3A3E7A'); gg.addColorStop(1, NAVY2); }
x.fillStyle = gg; x.fillRect(D.x - D.r, D.y - D.r, D.r * 2, D.r * 2);
if (st.inside) st.inside();
if (kind === 'was' && a > 0) {
x.fillStyle = 'rgba(185,178,255,' + (.35 * a) + ')';
x.beginPath(); x.moveTo(D.x - D.r, D.y + 30);
for (i = 0; i <= 20; i++) { x.lineTo(D.x - D.r + i * (D.r * 2 / 20), D.y + 30 + Math.sin(i * .9 + t * 9) * 7); }
x.lineTo(D.x + D.r, D.y + D.r); x.lineTo(D.x - D.r, D.y + D.r); x.closePath(); x.fill();
for (i = 0; i < 9; i++) { var ph = (t * .9 + i * .37) % 1; x.strokeStyle = 'rgba(255,255,255,' + (.7 * a * (1 - ph)) + ')'; x.lineWidth = 3; x.beginPath(); x.arc(D.x - 70 + ((i * 53) % 140), D.y + D.r - ph * D.r * 2, 6 + (i % 3) * 3, 0, 7); x.stroke(); }
}
if (kind === 'dry' && a > 0) {
for (i = 0; i < 4; i++) { var p2 = (t * .8 + i * .25) % 1; x.strokeStyle = 'rgba(255,214,102,' + (.6 * a * (1 - p2)) + ')'; x.lineWidth = 4; x.lineCap = 'round'; x.beginPath(); var bx = D.x - 45 + i * 30, by = D.y + 60 - p2 * 110; x.moveTo(bx, by); x.quadraticCurveTo(bx + 10, by - 12, bx, by - 24); x.quadraticCurveTo(bx - 10, by - 36, bx, by - 48); x.stroke(); }
}
x.strokeStyle = 'rgba(255,255,255,.35)'; x.lineWidth = 8; x.lineCap = 'round'; x.beginPath(); x.arc(D.x, D.y, D.r - 22, Math.PI * 1.1, Math.PI * 1.45); x.stroke();
x.restore();
var o = st.doorOpen || 0;
x.save(); x.translate(D.x - D.r - 18, D.y); x.scale(1 - o * .78, 1); x.translate(-(D.x - D.r - 18), -D.y);
x.strokeStyle = o > 0 ? 'rgba(217,213,255,' + (1 - o * .2) + ')' : '#C9C4FF'; x.lineWidth = 20; x.beginPath(); x.arc(D.x, D.y, D.r + 4, 0, 7); x.stroke();
x.fillStyle = NAVY; rr(D.x + D.r - 6, D.y - 22, 16, 44, 8); x.fill();
x.restore();
x.fillStyle = NAVY2; rr(M.x + 30, M.y + M.h - 4, 40, 14, 7); x.fill(); rr(M.x + M.w - 70, M.y + M.h - 4, 40, 14, 7); x.fill();
x.restore();
}
function quilt(w, h) {
x.strokeStyle = DEK2; x.lineWidth = Math.max(2, w / 120); x.lineCap = 'round';
var step = Math.max(26, w / 6);
for (var px = -w / 2 + step; px < w / 2 - 4; px += step) { x.beginPath(); x.moveTo(px, -h / 2); x.quadraticCurveTo(px + 6, 0, px, h / 2 + 10); x.stroke(); }
x.beginPath(); x.moveTo(-w / 2, -2); x.quadraticCurveTo(0, 8, w / 2, -2); x.stroke();
}
function ball(cx, cy, w, h, r, rot) {
x.save(); x.translate(cx, cy); x.rotate(rot || 0);
rr(-w / 2, -h / 2, w, h, r); x.fillStyle = DEK; x.fill();
x.save(); rr(-w / 2, -h / 2, w, h, r); x.clip(); quilt(w, h);
x.fillStyle = 'rgba(255,255,255,.35)'; rr(-w / 2 + r * .4, -h / 2 + 6, w - r * .8, h * .22, h * .11); x.fill();
x.restore();
x.setLineDash([2, 9]); x.strokeStyle = 'rgba(25,27,58,.22)'; x.lineWidth = 3; rr(-w / 2 + 10, -h / 2 + 10, w - 20, h - 20, Math.max(4, r - 8)); x.stroke(); x.setLineDash([]);
x.restore();
}
function drape(cx, cy, w, h, fluff) {
x.save(); x.translate(cx, cy);
var L = -w / 2, R = w / 2, T = -h / 2, B = h / 2;
function shape() {
x.beginPath();
x.moveTo(L + 30, T);
x.quadraticCurveTo(0, T - 10, R - 34, T + 2);
x.quadraticCurveTo(R + 4, T + 4, R + 2, T + 40);
x.lineTo(R + 6, B + 8);
var n = 6, sw = (R + 6 - (L - 6)) / n;
for (var i = 0; i < n; i++) { var x0 = R + 6 - i * sw; x.quadraticCurveTo(x0 - sw / 2, B + 22, x0 - sw, B + 8); }
x.lineTo(L - 6, T + 40);
x.quadraticCurveTo(L - 4, T + 2, L + 30, T);
x.closePath();
}
x.fillStyle = 'rgba(25,27,58,.18)'; x.save(); x.translate(4, 10); shape(); x.fill(); x.restore();
shape(); x.fillStyle = DEK; x.fill();
x.save(); shape(); x.clip(); quilt(w, h);
x.fillStyle = 'rgba(255,255,255,.32)'; rr(L + 40, T + 8, w - 80, h * .18, h * .09); x.fill();
x.restore();
x.setLineDash([2, 9]); x.strokeStyle = 'rgba(25,27,58,.2)'; x.lineWidth = 3; x.beginPath(); x.moveTo(L + 30, T + 12); x.quadraticCurveTo(0, T + 2, R - 30, T + 14); x.stroke(); x.setLineDash([]);
x.fillStyle = DEK_IN; x.beginPath(); x.moveTo(L + 2, T + 26); x.quadraticCurveTo(L + 6, T + 4, L + 34, T + 2); x.lineTo(L + 96, T + 6); x.quadraticCurveTo(L + 60, T + 40, L + 14, T + 78); x.closePath(); x.fill();
x.strokeStyle = DEK2; x.lineWidth = 3; x.beginPath(); x.moveTo(L + 96, T + 6); x.quadraticCurveTo(L + 60, T + 40, L + 14, T + 78); x.stroke();
x.restore();
if (fluff > 0 && fluff < 1) {
for (var k = 0; k < 6; k++) {
var ang = k / 6 * Math.PI * 2 + .4, d = w * .42 + fluff * 60, sx = cx + Math.cos(ang) * d, sy = cy + Math.sin(ang) * d * .45, s = 12 * (1 - Math.abs(fluff - .5) * 2) + 2;
x.fillStyle = 'rgba(255,214,102,' + (1 - fluff) + ')'; x.beginPath(); x.moveTo(sx, sy - s); x.quadraticCurveTo(sx, sy, sx + s, sy); x.quadraticCurveTo(sx, sy, sx, sy + s); x.quadraticCurveTo(sx, sy, sx - s, sy); x.quadraticCurveTo(sx, sy, sx, sy - s); x.fill();
}
}
}
function bed() {
var b = BED;
x.fillStyle = 'rgba(0,0,0,.18)'; x.beginPath(); x.ellipse(b.x + b.w / 2, b.y + 272, b.w / 2 + 20, 16, 0, 0, 7); x.fill();
x.fillStyle = LILA; rr(b.x + 10, b.y - 60, 170, 210, 44); x.fill();
x.fillStyle = 'rgba(25,27,58,.12)'; rr(b.x + 30, b.y - 40, 130, 170, 30); x.fill();
x.fillStyle = NAVY2; rr(b.x, b.y + 150, b.w, 70, 26); x.fill();
x.fillStyle = LILA2; x.globalAlpha = .25; rr(b.x + 20, b.y + 168, b.w - 40, 8, 4); x.fill(); x.globalAlpha = 1;
x.fillStyle = NAVY2; rr(b.x + 40, b.y + 210, 26, 60, 10); x.fill(); rr(b.x + b.w - 66, b.y + 210, 26, 60, 10); x.fill();
x.fillStyle = WHITE; rr(b.x + 20, b.y + 60, b.w - 30, 100, 30); x.fill();
x.strokeStyle = 'rgba(25,27,58,.10)'; x.lineWidth = 4; x.beginPath(); x.moveTo(b.x + 50, b.y + 130); x.lineTo(b.x + b.w - 40, b.y + 130); x.stroke();
}
function pillow(t, wink) {
var br = 1 + Math.sin(t / DUR * Math.PI * 2 * 4) * .012;
x.save(); x.translate(272, 708); x.rotate(-0.12); x.scale(br, 1 / br);
var w = 210, h = 136, L = -w / 2, R = w / 2, T = -h / 2, B = h / 2;
function shape(i) {
i = i || 0;
x.beginPath();
x.moveTo(L + i, T + i);
x.quadraticCurveTo(0, T + 18, R - i, T - 6 + i);
x.quadraticCurveTo(R - 18 - i, 0, R + 4 - i, B + 2 - i);
x.quadraticCurveTo(0, B - 16, L - 2 + i, B + 6 - i);
x.quadraticCurveTo(L + 18 + i, 0, L + i, T + i);
x.closePath();
}
x.fillStyle = 'rgba(25,27,58,.22)'; x.save(); x.translate(6, 12); shape(); x.fill(); x.restore();
shape(); x.fillStyle = WHITE; x.fill();
x.lineJoin = 'round'; x.strokeStyle = '#C9C4FF'; x.lineWidth = 5; shape(); x.stroke();
x.setLineDash([2, 8]); x.lineCap = 'round'; x.strokeStyle = LILA; x.lineWidth = 2.5; shape(12); x.stroke(); x.setLineDash([]);
x.save(); x.translate(0, 4); x.scale(.42, .42); x.translate(-210, -150);
x.strokeStyle = NAVY; x.lineWidth = 9; x.lineCap = 'round';
if (wink > 0 && wink < 1) {
var op = Math.sin(wink * Math.PI);
x.fillStyle = NAVY; x.beginPath(); x.ellipse(170, 138, 14, 14 * op + 1.5, 0, 0, 7); x.fill();
if (op > .6) { x.fillStyle = WHITE; x.beginPath(); x.arc(176, 131, 4.5, 0, 7); x.fill(); }
if (op < .3) { x.beginPath(); x.moveTo(148, 140); x.quadraticCurveTo(170, 162, 192, 140); x.stroke(); }
} else { x.beginPath(); x.moveTo(148, 140); x.quadraticCurveTo(170, 162, 192, 140); x.stroke(); }
x.beginPath(); x.moveTo(228, 140); x.quadraticCurveTo(250, 162, 272, 140); x.stroke();
x.fillStyle = PINK; x.beginPath(); x.arc(138, 180, 17, 0, 7); x.fill(); x.beginPath(); x.arc(282, 180, 17, 0, 7); x.fill();
x.lineWidth = 7; x.beginPath();
if (wink > 0 && wink < 1) { x.moveTo(190, 184); x.quadraticCurveTo(210, 206, 230, 184); } else { x.moveTo(198, 186); x.quadraticCurveTo(210, 196, 222, 186); }
x.stroke();
x.restore();
x.restore();
}
function zzz(t, alpha) {
if (alpha <= 0) return;
x.save();
for (var i = 0; i < 3; i++) { var ph = (t * .35 + i * .33) % 1; x.fillStyle = 'rgba(217,213,255,' + (alpha * Math.sin(ph * Math.PI)) + ')'; x.font = '800 ' + (24 + i * 8) + 'px ' + FONT; x.fillText(i == 2 ? 'Z' : 'z', 370 + ph * 40 + i * 16, 640 - ph * 90 - i * 10); }
x.restore();
}
function arc(p0, p1, lift, u) { var mx = (p0.x + p1.x) / 2, my = Math.min(p0.y, p1.y) - lift, a = (1 - u) * (1 - u), b = 2 * (1 - u) * u, cc = u * u; return { x: a * p0.x + b * mx + cc * p1.x, y: a * p0.y + b * my + cc * p1.y }; }
function draw(t) {
t = ((t % DUR) + DUR) % DUR;
x.clearRect(0, 0, W, H);
var washDoor = Math.max(seg(t, .5, .8) - seg(t, 1.55, 1.8), seg(t, 3.05, 3.3) - seg(t, 4.2, 4.4));
var dryDoor = Math.max(seg(t, 3.6, 3.9) - seg(t, 4.1, 4.35), seg(t, 5.35, 5.6) - seg(t, 6.2, 6.45));
var washOn = seg(t, 1.7, 1.9) - seg(t, 3.0, 3.15), dryOn = seg(t, 4.35, 4.55) - seg(t, 5.25, 5.4);
var inW = null, inD = null;
if (t >= 1.6 && t < 3.25) { var a1 = (t - 1.6) * 9; inW = function () { ball(WD.x + Math.cos(a1) * 28, WD.y + Math.sin(a1) * 28, 120, 100, 48, a1 * 1.3); }; }
if (t >= 4.1 && t < 5.45) { var a2 = (t - 4.1) * 7; inD = function () { ball(DD.x + Math.cos(a2) * 26, DD.y + Math.sin(a2) * 26, 124, 104, 50, a2 * 1.2); }; }
machine(WASH, 'was', t, { shake: washOn * Math.sin(t * 60) * 3, doorOpen: washDoor, active: washOn, inside: inW });
machine(DRY, 'dry', t, { shake: dryOn * Math.sin(t * 55) * 2, doorOpen: dryDoor, active: dryOn, inside: inD });
bed();
var wink = seg(t, 6.75, 7.25);
pillow(t, wink);
var BALL = { w: 150, h: 128, r: 60 }, p, u, m;
if (t < 0.7 || t >= 6.4) {
var w = FLAT.w, h = FLAT.h, cy = FLAT.cy, fl = 0;
if (t >= 6.4) { u = seg(t, 6.4, 6.95); var sq = Math.sin(u * Math.PI * 2.2) * Math.exp(-u * 3.2); w = FLAT.w * (1 + sq * .06); h = FLAT.h * (1 - sq * .22); cy = FLAT.cy + sq * 10; fl = u; }
if (t < 0.7) { cy -= eout(seg(t, .45, .7)) * 14; }
drape(FLAT.cx, cy, w, h, fl);
} else if (t < 1.6) {
u = eio(seg(t, .7, 1.6)); p = arc({ x: FLAT.cx, y: FLAT.cy - 14 }, { x: WD.x, y: WD.y }, 260, u);
m = eout(seg(t, .7, 1.05)); var shr = seg(t, 1.35, 1.6);
ball(p.x, p.y, lerp(lerp(FLAT.w, BALL.w, m), 110, shr), lerp(lerp(FLAT.h, BALL.h, m), 94, shr), lerp(FLAT.r, BALL.r, m), u * Math.PI * 1.6);
} else if (t >= 3.25 && t < 4.1) {
u = eio(seg(t, 3.25, 4.1)); p = arc({ x: WD.x, y: WD.y }, { x: DD.x, y: DD.y }, 180, u);
var g = Math.sin(u * Math.PI); ball(p.x, p.y, lerp(110, BALL.w, g), lerp(94, BALL.h, g), 55, -u * Math.PI * 1.4);
} else if (t >= 5.45 && t < 6.4) {
u = eio(seg(t, 5.45, 6.4)); p = arc({ x: DD.x, y: DD.y }, { x: FLAT.cx, y: FLAT.cy }, 200, u);
m = ein(seg(t, 6.0, 6.4)); var g2 = Math.sin(seg(t, 5.45, 6.0) * Math.PI / 2);
ball(p.x, p.y, lerp(lerp(110, BALL.w * 1.12, g2), FLAT.w, m), lerp(lerp(94, BALL.h * 1.12, g2), FLAT.h, m), lerp(58, FLAT.r, m), u * Math.PI * 1.2 * (1 - m));
}
zzz(t, 1 - seg(t, .3, .6) + seg(t, 7.6, 8.0));
}
return draw;
}
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
canvases.forEach(function (c) {
c.width = W; c.height = H;
var draw = setup(c), visible = true, start = null, raf = null;
var wrap = c.closest('[data-lp-hero-media]');
if (wrap) wrap.classList.add('is-ready');
draw(0.2);
if (reduce) { draw(7.1); return; }
function loop(now) { if (start === null) start = now; draw((now - start) / 1000); raf = visible ? requestAnimationFrame(loop) : null; }
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible && !raf) raf = requestAnimationFrame(loop); }).observe(c);
} else { raf = requestAnimationFrame(loop); }
if (document.fonts && document.fonts.load) document.fonts.load('800 30px ' + FONT);
});
})();
